import React, { ReactNode } from "react";
import { TablePagination, Typography, Skeleton } from "@mui/material";
import { Switch, Case, Default } from "react-if";
import clsx from "clsx";

import Panel from "../../../../components/panel/panel";
import FixedScrollSectionTemplate from "./fixed-scroll-section";

export interface ITableListPageState<F> {
  filters: F;
  perPage: number;
  count: number;
  currentPage: number;
  perPageOptions: number[];
}

export interface ITableListPageMethods {
  updateFilters: (params: any) => void;
  updateCurrentPage: (currentPage: number) => void;
  updatePerPage: (perPage: number) => void;
  updateCount: (perPage: number) => void;
}

interface ITableListTemplate {
  tableListMethods: ITableListPageMethods;
  tableListState: ITableListPageState<any>;
  isLoading: boolean;
  isEmpty: boolean;
  title: ReactNode;
  table: ReactNode;
}

export const getTableListMethods = (state: ITableListPageState<any>) => ({
  updateFilters(filters: any) {
    state.filters = filters;
  },
  updateCurrentPage(currentPage: number) {
    state.currentPage = currentPage;
  },
  updatePerPage(perPage: number) {
    state.perPage = perPage;
  },
  updateCount(count: number) {
    state.count = count;
  },
});

const TableListTemplate = (params: ITableListTemplate) => {
  const { isLoading, isEmpty, table, tableListMethods, tableListState, title } =
    params;
  return (
    <FixedScrollSectionTemplate classname="flex h-5/6">
      <div className="flex-grow">
        <Panel title={title}>
          <Switch>
            <Case condition={isLoading}>
              <Skeleton width="100%" height="100%" variant="rectangular" />
            </Case>
            <Case condition={isEmpty}>
              <div className="flex h-full flex-col items-center justify-center gap-8">
                <Typography className="w-96 text-center" variant="body1">
                  No hay datos para mostrar
                </Typography>
              </div>
            </Case>
            <Default>
              <div className={clsx("h-full overflow-y-auto")}>{table}</div>
              <div>
                <TablePagination
                  rowsPerPageOptions={tableListState.perPageOptions}
                  component="div"
                  count={tableListState.count}
                  rowsPerPage={tableListState.perPage}
                  page={tableListState.currentPage}
                  onPageChange={(event: any, page: any) => {
                    tableListMethods.updateCurrentPage(page);
                  }}
                  onRowsPerPageChange={(e: any) => {
                    const perPage = Number(e.target.value);
                    tableListMethods.updatePerPage(perPage);
                  }}
                  labelRowsPerPage={`Filas por página`}
                />
              </div>
            </Default>
          </Switch>
        </Panel>
      </div>
    </FixedScrollSectionTemplate>
  );
};

export default TableListTemplate;
